import { any, curry, isEmpty, isNil, not } from "ramda";

export const tap = curry((f, x) => {
  if (!isNil(x) && typeof x.tap === "function") {
    return x.tap(f);
  } else {
    f(x);
    return x;
  }
});

export const isBlank = value =>
  isNil(value) || isEmpty(value) || value === undefined;

export const notBlank = value => not(isBlank(value));

export const notNil = val => not(isNil(val));

export const anyNotBlank = any(notBlank);
